import { isBrowser } from './next';

let ua = '';

if (isBrowser) {
  ua = navigator.userAgent.toLowerCase();
}

const contains = (...strs: string[]) => strs.some((str) => ua.includes(str.toLowerCase()));

/** ==== browserName & osName ==== **/

const getBrowserName = () => {
  switch (true) {
    case contains('micromessenger'):
      return 'wechat';
    case contains('feishu'):
      return 'feishu';
    case contains('dingtalk'):
      return 'dingtalk';
    case contains('wxwork'):
      return 'workweixin';
    case contains('mqqbrowser'):
      return 'qqbrowser';
    case contains('qq') && !contains('mqqbrowser'):
      return 'qq';
    case contains('opera', 'opr'):
      return 'opera';
    case contains('edg'):
      return 'edge';
    case contains('chrome'):
      return 'chrome';
    case contains('safari'):
      return 'safari';
    case contains('firefox'):
      return 'firefox';
    case contains('msie', 'rv:'):
      return 'ie';
    default:
      return 'unknown';
  }
};

const getOSName = () => {
  switch (true) {
    case contains('android', 'linux'):
      return 'Android';
    case contains('iphone'):
      return 'iPhone';
    case contains('ipad'):
      return 'iPad';
    case contains('windows phone'):
      return 'Windows Phone';
    case contains('mac'):
      return 'Mac';
    case contains('windows'):
      return 'Windows';
    default:
      return 'unknown';
  }
};

export const browserName = getBrowserName();
export const osName = getOSName();

/** ==== browser ==== **/

const getSafariMajorVersion = () => {
  if (!contains('safari')) return;
  const match = ua.match(/version\/(\d+)/i);
  if (match) {
    return Number(match[1]);
  }
};

export const isFireFox = contains('firefox');

export const isSafari =
  contains('safari') && !contains('chrome') && !contains('android') && !contains('feishu');

export const safariMajorVersion = getSafariMajorVersion();

export const isSafariBelow16 = isSafari && safariMajorVersion && safariMajorVersion < 16;

/** ==== os ==== **/

export const isWindows = contains('win32', 'wow32', 'win64', 'wow64');
export const isAndroid = contains('android', 'adr');

const isMobileExceptNewIPad = contains(
  'android',
  'webos',
  'iphone',
  'ipod',
  'ipad',
  'blackberry',
  'harmonyos',
);

// 坑！！！！
// 老版本 ipad 可以通过 ua 判断， 新版 ipad 中 safari 和 macos 一样，所以需要复合判断,  判断移动端的设备需要考虑新版 ipad 的情况
const canTouch = typeof window !== 'undefined' && 'ontouchstart' in window;
const isIOSOrOldVersionIpadOrSomeOtherIosDevice = contains('iphone', 'ipod', 'ios');
const isOldVersionIpad = contains('ipad');
const isNewVersionIPad = isSafari && !isIOSOrOldVersionIpadOrSomeOtherIosDevice && canTouch;
export const isIpad = isOldVersionIpad || isNewVersionIPad;
export const isIOS = isIOSOrOldVersionIpadOrSomeOtherIosDevice || isIpad;
export const isIos13 = isIOS && contains('os 13');

/** ==== mobile/pc ==== **/

export const isMobileByUA = isMobileExceptNewIPad || isNewVersionIPad;

/** ==== vendor ==== **/

export const isDingtalk = contains('dingtalk');
export const isFeishu = contains('feishu');

export const isWechat = contains('micromessenger');
export const isWorkWeixin = contains('wxwork');

export const isQQInsideBrowser = contains('qq') && contains('qqtheme');
export const isQQBrowser = contains('mqqbrowser') && !contains('qqtheme');
export const isIosQQBrowser = isQQBrowser && isIOS;

export const isSamsungBrowser = contains('samsungbrowser');

// 导出是否是小程序
export const isMiniProgram = contains('miniprogram');

export const isPc = !isMobileByUA && !isMiniProgram;
